export enum PrimarySectionColBlock {
  Root = 'PrimarySectionCol',
}

export enum PrimarySectionColModifier {
  FullWidth = 'fullWidth',
}
